import React from 'react';
import PropTypes from 'prop-types';

const Tag = props => {
  const { className, text } = props;
  if (!text) return;
  return (
    <div className={className} data-testid="tag" {...props}>
      <span className="tag">{text}</span>
    </div>
  );
};

Tag.defaultProps = {
  skin: 'grey'
};

Tag.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  skin: PropTypes.oneOf(['red', 'grey', 'green', 'yellow', 'blue'])
};

export default Tag;
